import {doc} from './docs.js';

doc(
    "zl",
    {
        "mode": "mode",
    },
    "Concatenates the list arguments together",
    undefined,
    {
        isHot: true
    }
);

export const zl = (object, arg) => {
    let list = [];
    return (msg) => {
        msg = msg[0];
        let _mode = arg();
        if (typeof msg === "string") {
            _mode = msg;
        } 
        list = msg[0];

        let _list = [... list];
        switch (_mode) {
        case "rev":
            return [_list.reverse()];
        }
    };
};

